import { render, staticRenderFns } from "./RenovacionesComponent.vue?vue&type=template&id=70f1f57f"
import script from "./RenovacionesComponent.vue?vue&type=script&lang=js"
export * from "./RenovacionesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports